// extracted by mini-css-extract-plugin
export var active = "_i1-e";
export var blink = "_i1-f";
export var dropDownSelector = "_i1-5";
export var dropDownWrapper = "_i1-4";
export var fakeCursor = "_i1-d";
export var fontSizeButton = "_i1-7";
export var formQuillEditor = "_i1-0";
export var pressed = "_i1-g";
export var qlBlank = "_i1-1";
export var textFormattingToolbar = "_i1-2";
export var textFormattingToolbarClosed = "_i1-3";
export var textFormattingToolbarInline = "_i1-6";
export var textToolbarOption = "_i1-8";
export var toolbarCell = "_i1-a";
export var toolbarCellCollapsed = "_i1-b";
export var toolbarOptionHitArea = "_i1-c";
export var toolbarOverflow = "_i1-9";